import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-modal-template',
  imports: [
    NgTemplateOutlet,
    ReactiveFormsModule,
    ButtonComponent
  ],
  templateUrl: './modal-template.component.html',
  styleUrl: './modal-template.component.scss'
})
export class ModalTemplateComponent implements OnInit {

  protected readonly zbpIconNames = zbpIconNames;

  /**
   * Can provide string or TemplateRef.
   *
   * String will be automatically styled with the standard header styling.
   *
   * TemplateRef will also have the standard header styling applied that can be customized.
   */
  @Input() modalHeader?: string | TemplateRef<any>;
  @Input() bodyContent?: TemplateRef<any>;
  @Input() footerContent?: TemplateRef<any>;
  @Input() footerLeftContent?: TemplateRef<any>;
  /** Used when footer should span the entire width */
  @Input() footerContentFull?: TemplateRef<any>;
  @Input() showCloseX: boolean = false;
  @Input() isScrollable: boolean = true;

  /**
   * When modalHeader is typeof TemplateRef, it's cast to a TemplateRef,
   * then assigned to modalHeaderRef for the view to handle properly.
   */
  modalHeaderRef: TemplateRef<any> = null;
  isHeaderTemplateRef: boolean = false;

  constructor(private activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    if (this.modalHeader && typeof this.modalHeader !== 'string') {
      this.isHeaderTemplateRef = true;
      this.modalHeaderRef = this.modalHeader as TemplateRef<any>;
    }
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

}
